<script>
import MethodButtonBase from './MethodButtonBase';
import IconSimplySign from '../../assets/svg/simply-sign-logo.svg';
export default {
  name: 'SimplySignButton',
  components: {
    MethodButtonBase,
    IconSimplySign,
  },
}
</script>

<template>
  <MethodButtonBase>
    <template v-slot:slot1>
      <IconSimplySign :class="$style.icon" />
    </template>
  </MethodButtonBase>
</template>


<style lang="scss" module>
.icon {
  display: block;
  width: 125px;
  height: auto;
}
</style>
